export var redirectTo = function redirectTo(url) {
  window.location.href = url;
};